// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"wizard__wrapper--2khhF","sidebar":"wizard__sidebar--2RgPQ","main":"wizard__main--aQNmE","content":"wizard__content--lmNPj"};